import clsx from 'clsx'

import cl from './slider-pagination-simple.module.scss'

type SliderPaginationSimpleProps = {
	className?: string
	count?: number
	activeIndex?: number
}

export const SliderPaginationSimple = (props: SliderPaginationSimpleProps) => {
	const { className, count = 0, activeIndex = 0 } = props

	const array = Array(count).fill(null)

	return (
		<div className={clsx(cl.pagination, className)}>
			{array.map((_, i) => (
				<div
					key={i}
					className={clsx(cl.pagination__el, {
						[cl.pagination__el__active]: i === activeIndex
					})}
				/>
			))}
		</div>
	)
}
